import { connect } from 'react-redux'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'

// Containers
import BrowserSkillAreaSamy from 'app/views/containers/BrowserSkillAreaSamy'

// Redux
import { getContentById } from 'app/state/modules/content'

// Utils
import analytics from 'app/views/utils/analytics'
import isMobileDevice from 'app/views/utils/mobile'

const propTypes = {}
const defaultProps = {}

class SamyWorm extends React.Component {
  constructor(props) {
    super(props)

    this.handleClickBack = this.handleClickBack.bind(this)
    this.handleClickCircle = this.handleClickCircle.bind(this)
    this.handleClickNext = this.handleClickNext.bind(this)
    this.handleClickDone = this.handleClickDone.bind(this)
  }

  componentDidMount() {
    this.props.getContentById('1040e3e0-6c6b-11e9-92d8-0a0452f0a95c')
    analytics.page('samy')
  }

  handleClickBack(stepId) {
    analytics.track('samy-back', { stepId })
  }

  handleClickCircle(stepId) {
    analytics.track('samy-circle', { stepId })
  }

  handleClickDone(stepId) {
    analytics.track('samy-done', { stepId })
  }

  handleClickNext(stepId) {
    analytics.track('samy-next', { stepId })
  }

  render() {
    if (!Object.keys(this.props.contentDetails).includes('1040e3e0-6c6b-11e9-92d8-0a0452f0a95c')) {
      return (
        <div className="uk-section uk-text-center">
          <div className="uk-container">
            <div data-uk-spinner="" />
          </div>
        </div>
      )
    }
    if (isMobileDevice()) {
      return (
        <div className="uk-section">
          <div className="uk-container uk-text-center">
            <h3 className="uk-text-bold">Looks like you are on mobile...</h3>
            <p>
              Thanks for checking out our demo while on the go, but our tools are not available on
              mobile.
            </p>
            <Link className="uk-button uk-button-primary" to="/">Back To Homepage</Link>
          </div>
        </div>
      )
    }
    const content = this.props.contentDetails['1040e3e0-6c6b-11e9-92d8-0a0452f0a95c']
    return (
      <BrowserSkillAreaSamy
        handleClickBack={(stepId) => { this.handleClickBack(stepId) }}
        handleClickCircle={(stepId) => { this.handleClickCircle(stepId) }}
        handleClickNext={(stepId) => { this.handleClickNext(stepId) }}
        handleClickDone={(stepId) => { this.handleClickDone(stepId) }}
        title={content.title}
        description={content.description}
        steps={content.steps}
        tabs={content.tabs}
        ecsTaskDefinition={content.ecs_task_definition}
        currentProgress={0}
        hasTest={false}
        appType={content.app_type}
        contentType={content.content_type}
        lessonCompletionURL="/register"
        lessonCompletionText="Create an Account"
      />

    )
  }
}

SamyWorm.propTypes = propTypes
SamyWorm.defaultProps = defaultProps

const mapStateToProps = state => ({
  // content
  contentDetails: state.content.contentDetails,
})

const mapDispatchToProps = dispatch => ({
  getContentById: contentId => dispatch(getContentById(contentId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SamyWorm))
